import { PageDocumentView } from '~/app/pages/Documents/View';

import { PageDocumentsRedirect } from './Redirect';
import { REPORTING } from './Reporting';
import { PageDailyStatements, PageMonthlyStatements, PageStatementsSection } from './Statements';

export const DOCUMENTS = {
  ...REPORTING,
  DocumentsRedirect: PageDocumentsRedirect,
  DocumentView: PageDocumentView,
  StatementsSection: PageStatementsSection,
  MonthlyStatements: PageMonthlyStatements,
  DailyStatements: PageDailyStatements,
} as const;
